/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for Pricing
 * The Selling Partner API for Pricing helps you programmatically retrieve product pricing and offer information for Amazon Marketplace products.
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Indicates whether the offer is a B2B or B2C offer
 */

export const OfferCustomerType = {
    B2C: 'B2C',
    B2B: 'B2B',
} as const;

export type OfferCustomerType = typeof OfferCustomerType[keyof typeof OfferCustomerType];



